import React, { Component } from 'react';

import PropTypes from 'prop-types';

import MUITable from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';

export default class Table extends Component {
  static propTypes = {
    cols: PropTypes.arrayOf(
      PropTypes.shape({
        prop: PropTypes.string.isRequired,
        label: PropTypes.string,
        render: PropTypes.function,
        editor: PropTypes.function
      })
    ).isRequired,

    rows: PropTypes.arrayOf(PropTypes.object).isRequired,

    props: PropTypes.object,
    headProps: PropTypes.object,
    headCellProps: PropTypes.object,
    bodyProps: PropTypes.object,
    rowProps: PropTypes.object,
    cellProps: PropTypes.object,

    horizontal: PropTypes.bool,

    selectedCol: PropTypes.number,
    selectedRow: PropTypes.number,

    noHead: PropTypes.bool
  };

  static defaultProps = {
    props: {},
    headProps: {},
    headCellProps: {},
    bodyProps: {},
    rowProps: {},
    cellProps: {},

    horizontal: false,

    selectedCol: -1,
    selectedRow: -1,

    noHead: false
  };

  el = {
    root: MUITable,
    head: TableHead,
    body: TableBody,
    row: TableRow,
    cell: TableCell
  };

  render() {
    const { cols, rows, horizontal, noHead } = this.props;

    const selected = {
      col: this.props.selectedCol,
      row: this.props.selectedRow
    };

    const { el } = this;

    const props = {
      root: this.props.props,
      head: this.props.headProps,
      headCell: this.props.headCellProps,
      body: this.props.bodyProps,
      row: this.props.rowProps,
      cell: this.props.cellProps
    };

    if (horizontal)
      return (
        <el.root {...props.root}>
          <el.body {...props.body}>
            {rows.map((row, i) =>
              cols.map((col, j) => (
                <el.row key={`row-${i}-col-${j}`} {...props.row}>
                  {!noHead && (
                    <el.cell variant="head" {...props.headCell}>
                      {col.label || col.prop}
                    </el.cell>
                  )}

                  <el.cell {...props.cell}>
                    {selected.row === i && selected.col === j && col.editor
                      ? col.editor(rows[i][col.prop], i, j, rows[i])
                      : col.render
                        ? col.render(rows[i][col.prop], i, j, rows[i])
                        : rows[i][col.prop]}
                  </el.cell>
                </el.row>
              ))
            )}
          </el.body>
        </el.root>
      );

    return (
      <el.root {...props.root}>
        {!noHead && (
          <el.head {...props.head}>
            <el.row {...props.row}>
              {cols.map((col, i) => (
                <el.cell key={`col-${i}`} {...props.headCell}>
                  {col.label || col.prop}
                </el.cell>
              ))}
            </el.row>
          </el.head>
        )}

        <el.body {...props.body}>
          {rows.map((row, i) => (
            <el.row key={`row-${i}`} {...props.row}>
              {cols.map((col, j) => (
                <el.cell key={`row-${i}-col-${j}`} {...props.cell}>
                  {selected.row === i && selected.col === j && col.editor
                    ? col.editor(row[col.prop], i, j, rows[i])
                    : col.render
                      ? col.render(row[col.prop], i, j, rows[i])
                      : row[col.prop]}
                </el.cell>
              ))}
            </el.row>
          ))}
        </el.body>
      </el.root>
    );
  }
}



// WEBPACK FOOTER //
// ./src/lib/index.js